import React, {Component} from 'react'
import Flickity from 'flickity'

export default class FlickitySlider extends Component {
  state = {
    ready: false,
    slides: []
  }

  componentDidMount() {
    this.initFlickity()
  }

  componentWillReceiveProps({active, ready}) {
    if (active !== this.props.active) {
      this.flkty.select(active)
    }

    if(ready !== this.props.ready && ready && active === 0){
      clearTimeout(this.timer)
      if (this.flkty) this.flkty.destroy()

      this.timer = setTimeout(() => {
        this.initFlickity()
      }, 200)
    }
  }

  componentWillUnmount () {
    this.flkty.destroy()
    clearTimeout(this.timer)
  }

  shouldComponentUpdate({active, ready}) {
    return ready !== this.props.ready || active !== this.props.active
  }

  initFlickity = () => {
    this.flkty = new Flickity( this.sliderProduct, {
      lazyLoad: 1,
      ...this.props.options,
    })
    
    this.slides = document.querySelectorAll('.product-template')
    this.bottom = window.innerWidth > 1024 ? 80 : 70
    
    this.viewport = this.sliderProduct.querySelector('.flickity-viewport')
    if (this.slides[0] && this.slides[0].querySelector('.template-scroll')) {
      this.viewport.style.height = `${ this.slides[0].querySelector('.template-scroll').offsetHeight + this.bottom }px`
    }

    this.onChange()
  }

  onChange = () => {
    this.flkty.on('change', async (index) => {
      this.props.callback(index)
      const scrollTemplate = this.slides[index].querySelector('.template-scroll')
      if (this.slides[index] && scrollTemplate) {
        this.viewport.style.height = `${ scrollTemplate.offsetHeight + this.bottom }px`
      }
      document.querySelector('.app-body').scrollIntoView()
    })
  }

  render() {
    const {children, className} = this.props
    return (
      <div className={className} ref={(flickity) => this.sliderProduct = flickity}>
        {
         children
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/FlickitySlider.js